module.exports = __webpack_public_path__ + "img/stock1.c6443fa4.png";